// @ngInject
function InventoryingApiService($q, DS, DSHttpAdapter, ResourcesService, $cookies, $window) {
    return {
        getAll: getAll,
        getById: getById,
        getHeadInfoById: getHeadInfoById,
        getInventoryItemGroups: getInventoryItemGroups,
        getInventoryTypes: getInventoryTypes,
        createInventory: createInventory,
        updateInventory: updateInventory,
        getInventoryDataForArticle: getInventoryDataForArticle,
        uploadParseFile: uploadParseFile,
        getInventoryRowsRelatedToItemGroup: getInventoryRowsRelatedToItemGroup,
        getInventoryRowsRelatedToArticle: getInventoryRowsRelatedToArticle,
        getInventoryRows: getInventoryRows,
        approveItemGroupRelatedRows: approveItemGroupRelatedRows,
        approveInventoryRow: approveInventoryRow,
        approveInventoryRows: approveInventoryRows,
        getInventoryReport: getInventoryReport,
        getInventoryMainGroups: getInventoryMainGroups,
        getInventoryFileErrors: getInventoryFileErrors,
        getInventoryBrands: getInventoryBrands,
        getMainGroupInventoryRows: getMainGroupInventoryRows,
        getBrandInventoryRows: getBrandInventoryRows,
        uploadInventoryFile: uploadInventoryFile,
        queueInventoryForFinalization: queueInventoryForFinalization,
        getPendingInventoryCount: getPendingInventoryCount
    };

    function getAll(page, filter, pageSize) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories', {params: params}).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getById(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getPendingInventoryCount(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/pendingcount/' + articleId ).then(function(response) {
            console.log("response", response)
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryMainGroups(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/maingroups').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryBrands(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/brands').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMainGroupInventoryRows(inventoryId, mainGroupId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/maingroups/' + mainGroupId + '/inventoryrows').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getBrandInventoryRows(inventoryId, brandId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/brands/' + brandId + '/inventoryrows').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getHeadInfoById(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/head').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function uploadParseFile(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'inventories/' + inventoryId + '/inventoryfile').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateInventory(data) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'inventories/', data).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryRowsRelatedToItemGroup(inventoryId, itemGroupId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/itemgroups/' + itemGroupId + '/inventoryrows').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryRowsRelatedToArticle(inventoryId, articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/articles/' + articleId + '/inventoryrows').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryRows(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/inventoryrows').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryFileErrors(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/file/errors').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryItemGroups(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/itemgroups').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryDataForArticle(inventoryId, articleId) {
        var deferred = $.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'inventories/' + inventoryId + '/articles/' + articleId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryTypes() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'types/inventory').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createInventory(data) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'inventories', data).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function approveItemGroupRelatedRows(inventoryId, itemGroupId) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'inventories/' + inventoryId + '/itemgroups/' + itemGroupId + '/approve').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function approveInventoryRow(inventoryId, inventoryRowId) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'inventories/' + inventoryId + '/inventoryrows/' + inventoryRowId + '/approve').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function approveInventoryRows(inventoryId, inventoryRows) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'inventories/' + inventoryId + '/inventoryrows/approve', inventoryRows).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function uploadInventoryFile(inventoryId, fileData) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'inventories/' + inventoryId + '/uploadfile', fileData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function queueInventoryForFinalization(inventoryId) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'inventories/' + inventoryId + '/queueforfinalization').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getInventoryReport(inventoryId, language, format) {
        var deferred = $q.defer();

        //eg. inventoryId = '1', language = 'se', format = 'xls' => 'inventories/1/report/se/asxls'
        var url = DS.defaults.basePath + 'inventories/' + inventoryId + '/report/' + language + '/as' + format;
        DSHttpAdapter.GET(url, { responseType: 'arraybuffer' }).then(function(response) {
            var blob;
            if (format === 'pdf') {
                blob = new Blob([response.data], {type: 'application/pdf'});
            } else if (format === 'csv') {
                blob = new Blob([response.data], {type: 'application/csv'});
            } else if (format === 'xls') {
                blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
            }
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'report.' + format);

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s]){1,}(.pdf|.csv|.xls)/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('inventorying.api', [])
    .factory('InventoryingApiService', InventoryingApiService);
